import { render, staticRenderFns } from "./SoftwareComponentList.vue?vue&type=template&id=3b6bd682&scoped=true&"
import script from "./SoftwareComponentList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentList.vue?vue&type=style&index=0&id=3b6bd682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bd682",
  null
  
)

export default component.exports